import React from 'react';
const SaveIcon = ({
  width = '25px',
  height = '25px'
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Tick"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "25",
    height: "25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    clipPath: "url(#clip-Tick)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick_line",
    transform: "translate(1.836 448.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M19.708-443.7c-.193.09-1.11.991-6.578,6.454L6.779-430.9,4.291-433.38c-1.369-1.365-2.553-2.516-2.631-2.557a1.351,1.351,0,0,0-.917,0,1.115,1.115,0,0,0-.514.555,1,1,0,0,0,.033.872c.127.255,5.784,5.912,6.039,6.039a1.339,1.339,0,0,0,.419.111.734.734,0,0,0,.473-.086c.218-.1.88-.744,7.014-6.882s6.783-6.8,6.882-7.014a.741.741,0,0,0,.086-.477,1.044,1.044,0,0,0-.995-.974A.762.762,0,0,0,19.708-443.7Z",
    transform: "translate(0)"
  }))))

  // <svg id="Save" xmlns="http://www.w3.org/2000/svg" width="19.763" height="22" viewBox="0 0 19.763 22">
  //   <defs>
  //     <style>
  //       {` .cls-save-record-1 {
  //     fill: #504f4f;
  //   }`}
  //     </style>
  //   </defs>
  //   <g id="Group_6814" data-name="Group 6814">
  //     <g id="transition-_3_">
  //       <path
  //         id="Path_13213"
  //         data-name="Path 13213"
  //         className="cls-save-record-1"
  //         d="M88.322-479.82a3.734,3.734,0,0,0-2.417,1.924c-.377.719-.406.927-.406,2.805v1.681l.162.272a1.222,1.222,0,0,0,1.924.255c.348-.354.377-.51.377-2.144a5.593,5.593,0,0,1,.093-1.646,1.32,1.32,0,0,1,.614-.655c.209-.1.435-.11,6.711-.11s6.5.006,6.711.11a1.32,1.32,0,0,1,.614.655,5.621,5.621,0,0,1,.093,1.652,13.439,13.439,0,0,0,.064,1.663,1.344,1.344,0,0,0,.823.782,1.239,1.239,0,0,0,1.414-.562l.162-.272v-1.681c0-1.872-.029-2.069-.406-2.805a3.654,3.654,0,0,0-2.428-1.918c-.446-.11-.638-.116-7.071-.11C89.215-479.925,88.717-479.913,88.322-479.82Z"
  //         transform="translate(-85.5 479.926)"
  //       />
  //     </g>
  //     <g id="up-arrow" transform="translate(3.296 5.346)">
  //       <path
  //         id="Path_13214"
  //         data-name="Path 13214"
  //         className="cls-save-record-1"
  //         d="M52.7-511.564a.732.732,0,0,0-.239.1c-.06.044-1.411,1.386-3,2.985-2.278,2.291-2.907,2.941-2.969,3.064a1.052,1.052,0,0,0,0,.788.94.94,0,0,0,.87.556c.43,0,.355.066,2.341-1.914,1.565-1.555,1.788-1.769,1.895-1.788a.357.357,0,0,1,.368.142c.06.085.063.185.069,5.722l.009,5.637.082.173a.95.95,0,0,0,.462.493,1.027,1.027,0,0,0,.811.016,1.069,1.069,0,0,0,.49-.493l.072-.157.016-5.656c.013-4.515.025-5.672.057-5.725a.373.373,0,0,1,.456-.132c.038.019.867.83,1.844,1.8,1.98,1.97,1.879,1.889,2.309,1.882a.89.89,0,0,0,.685-.292.916.916,0,0,0,.258-.663c0-.427.195-.2-3.042-3.447-2.086-2.09-2.966-2.951-3.076-3.01a.757.757,0,0,0-.4-.094A2.121,2.121,0,0,0,52.7-511.564Z"
  //         transform="translate(-46.412 511.579)"
  //       />
  //     </g>
  //     <rect
  //       id="Rectangle_4123"
  //       data-name="Rectangle 4123"
  //       className="cls-save-record-1"
  //       width="19"
  //       height="2"
  //       rx="1"
  //       transform="translate(0.708 20)"
  //     />
  //   </g>
  // </svg>
  ;
};

export default SaveIcon;